<div>
  <router-outlet></router-outlet>
</div>
<div>
  <app-shared-components-interceptor-loader></app-shared-components-interceptor-loader>
</div>
<app-shared-components-spinner [preload]="loader"></app-shared-components-spinner>
